class GCCustomerGallery extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;
    this.list = this.querySelector('.gc-customer-photos__list');
    this.cards = [...this.querySelectorAll('.gc-customer-photos__card')];
    this.navigation = this.querySelector('.gc-customer-photos__navigation');
    if (!this.list || !this.navigation || !this.cards.length) return;
    this.abortController = new AbortController();
    this.buttons = [...this.navigation.querySelectorAll('button')];
    this.navigation.hidden = false;
    this.update = () => {
      const left = this.list.getBoundingClientRect().left;
      let active = 0;
      let distance = Infinity;
      this.cards.forEach((card, index) => {
        const delta = Math.abs(card.getBoundingClientRect().left - left);
        if (delta < distance) { distance = delta; active = index; }
      });
      this.buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === active)));
      const height = Math.ceil(this.cards[active].getBoundingClientRect().height) + 8;
      this.list.style.setProperty('--gc-active-height', height + 'px');
    };
    this.buttons.forEach((button) => button.addEventListener('click', () => {
      const card = this.cards[Number(button.dataset.photoIndex)];
      if (!card) return;
      const offset = card.getBoundingClientRect().left - this.list.getBoundingClientRect().left + this.list.scrollLeft;
      this.list.scrollTo({ left: offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }, { signal: this.abortController.signal }));
    this.list.addEventListener('scroll', () => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(this.update);
    }, { passive: true, signal: this.abortController.signal });
    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.list);
    this.cards.forEach((card) => this.resizeObserver.observe(card));
    this.update();
  }
  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
    this.resizeObserver?.disconnect();
    cancelAnimationFrame(this.frame);
  }
}
if (!customElements.get('gc-customer-gallery')) customElements.define('gc-customer-gallery', GCCustomerGallery);
